import React  from 'react';
import { Image, useTheme, Heading, Flex, Text, Link, View } from "@aws-amplify/ui-react";
import { useAuthenticator } from '@aws-amplify/ui-react';


export function LoginHeader() {
  const { tokens } = useTheme();
  return (
    <Image
      alt="quantIm"
      src={require('../shared/SUR_Quantim_HWeb_Positivo.png')}
      padding={tokens.space.medium}
    />
  );
}

export function SignInHeader() {
  const { tokens } = useTheme();

  return (
    <Heading level={3} padding={`${tokens.space.xl} ${tokens.space.xl} 0`}>
        <Image
          alt="quantIm"
          src={require('../shared/SUR_Quantim_HWeb_Positivo.png')}
          padding={tokens.space.medium}
        />
      <center>Ingrese a su cuenta</center>
    </Heading>
  );
}

export function SignInFooter() {
  const { toResetPassword } = useAuthenticator();
  const { tokens } = useTheme();

  return (
    <Flex justifyContent="center" padding={`0 0 ${tokens.space.medium}`}>
      <Link onClick={toResetPassword}>Reset contraseña</Link>
    </Flex>
  );
}


export function LoginFooter() {
  const { tokens } = useTheme();

  return (
    <Flex justifyContent="center" padding={tokens.space.medium}>
      <Text>&copy; All Rights Reserved</Text>
    </Flex>
  );
}
